import React from 'react'
import { Badge } from 'spa/member/components/Badge'

type LabelProps = {
  htmlFor: string
  label: string | React.ReactNode
  annotationNote?: string | React.ReactNode
}

export type QuestionnaireFormLabelProps = LabelProps & {
  noBadge?: boolean
  required: boolean
  className?: string
}

export const StyledQuestionnaireFormLabel: React.FC<QuestionnaireFormLabelProps> = ({
  htmlFor,
  label,
  annotationNote,
  noBadge = false,
  required = false,
  className = '',
}) => {
  return (
    <div className={`flex ${className}`} style={{ marginBottom: '12px' }}>
      {!noBadge && (
        <div className="flex items-center h-6 mr-2">
          <Badge badgeType="small" kind={required ? 'danger' : 'gray'} style={{ marginTop: '1px' }}>
            {required ? '必須' : '任意'}
          </Badge>
        </div>
      )}
      <div className="flex flex-col">
        <label
          htmlFor={htmlFor}
          className="text-member-gray-100 text-sm font-bold leading-6 m-0! items-center"
        >
          {label}
        </label>
        {annotationNote && (
            <span
            className="text-member-gray-100 text-xs font-normal text-left"
            style={{ lineHeight: '1.7' }}
            >
            {annotationNote}
            </span>
        )}
      </div>
    </div>
  )
}
